import React from 'react';
import { summarySummaryVFInputFieldData } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/summary-components/summary-v-f-input.css';

const SummaryVFInput = React.memo(({
  fieldData,
}) => {

  const {
    fieldTitle,
    displayValues,
  } = fieldData;

  return (
    <div className="summary-field-v-f-input">
      <p className="field-title">
        {fieldTitle}
      </p>
      <p className="field-value">
        {displayValues}
      </p>
    </div>
  );
});

SummaryVFInput.propTypes = {
  fieldData: summarySummaryVFInputFieldData,
};

export { SummaryVFInput };

